import type { Conversation } from '../../api/chat';
import type { ChatUnreadEntry } from '../../redux/slices/chatUnread';

export function buildChatUnreadEntries(
  conversations: Conversation[],
  currentUserId: string
): ChatUnreadEntry[] {
  const out: ChatUnreadEntry[] = [];
  for (const c of conversations) {
    if (!c.unread_count || c.unread_count <= 0) continue;

    let name = c.name?.trim() || '';
    if (!name && c.type === 'dm' && c.members) {
      const other = c.members.find((m) => m.user_id !== currentUserId);
      if (other) name = other.name;
    }
    if (!name) name = 'Conversation';

    const lastContent =
      (c as any).last_message?.content ??
      (c as any).last_message_content ??
      null;

    const lastMessageId =
      (c as any).last_message?.id ??
      (c as any).last_message_id ??
      undefined;

    out.push({
      conversationId: c.id,
      count: c.unread_count,
      name,
      avatarUrl: c.avatar_url,
      lastActivity: c.last_activity,
      lastContent,
      lastMessageId,
    });
  }
  return out;
}
